import { render } from "./WarrantyApplication.vue?vue&type=template&id=372be6b2"
import script from "./WarrantyApplication.vue?vue&type=script&lang=js"
export * from "./WarrantyApplication.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__